export default "__VITE_ASSET__D3hP196S__"